const KEY = 'roam_email_for_sign_in';

export const storeEmailForSignIn = (email: string) =>
  localStorage.setItem(KEY, email);

export const getEmailForSignIn = (): string | null =>
  localStorage.getItem(KEY);

export const clearEmailForSignIn = () =>
  localStorage.removeItem(KEY);
